import { gettext } from '@eventbrite/i18n';
import React from 'react';

export interface PromoCodeFormLinkProps {
    onClick: () => void;
}

export const PromoCodeFormLink: React.FunctionComponent<
    PromoCodeFormLinkProps
> = ({ onClick }) => (
    <div className="eds-g-cell eds-g-cell-8-12 eds-text-bm--fixed eds-text-color--ui-blue eds-button--none">
        <button
            className="eds-btn--none eds-link "
            onClick={onClick}
            data-automation="promo-code-form-link"
            data-spec="promo-code-form-link"
            data-testid="promo-code-form-link"
        >
            {gettext('Enter promo code')}
        </button>
    </div>
);
